import { flux } from '@/core/flux.module';

export function setDuplicatingItemId(id: string) {
  flux.dispatch('PROPERTIES_SET_DUPLICATING_ITEM_ID', { id });
}
